import { gsap, Power2, Back} from 'gsap';
import { Point, BLEND_MODES, Texture } from "pixi.js";
import { Sequence } from "../../../core/displayobject/Sequence";
import { SanQuentin2 } from "../../SanQuentin2";
import { SpinePlayer } from '../../../core/displayobject/SpinePlayer';
import { Helper } from '../../../core/utils/Helper';
import { SoundManager } from '../../config/sound/SoundManager';
import { SoundConfig } from '../../config/sound/SoundConfig';

export class SetupJumpingWildSymbol extends PIXI.Container {

    ID:number;
    ReelID:number;
    RowID:number;

    jw_Spine:SpinePlayer;
    seq_burn_FX: Sequence;

    jw_mult: PIXI.Sprite;
    multValue:number = 1;

    removed:boolean = false;

    timeline: gsap.core.Timeline;

    public get jwSpine():SpinePlayer{
        return this.jw_Spine;
    }

    constructor(_id:number, mult:boolean){
        super();
        this.ID = _id;
        this.sortableChildren = true;
        this.jw_Spine = this.addChild(new SpinePlayer("JW", true)); 
        if(mult){
            this.jw_mult = this.addChild(new PIXI.Sprite(SanQuentin2.assetLoader.getTextures("JW_Multiplier/X_2")[0]));
            this.jw_mult.anchor.set(0.5, 0.5);
            this.jw_mult.zIndex = 100;
        }
    }

    setActiveSpine(val:boolean):gsap.core.Timeline{
        this.removed = false;
        const tl = this.jwSpine.play({animation:val ? this.jw_mult ? "JW_activate_x2" : "JW_activate" : "JW_disactivate" ,showOnEnd:true});
        if(this.jw_mult){
            tl.to(this.jw_mult,{alpha: val ? 1 : 0.4, duration:tl.duration()/2},0);
        }
        if(val) {
            this.zIndex = this.ID;
            this.alpha = 1;
        }
        return tl;
    }

    jwRemoved():gsap.core.Timeline{
        if(this.removed) return Helper.setTimeline();
        SoundManager.playSoundEffect(SoundConfig.SETUP_MINI_EXPLODE);
        this.removed = true;
        const tl = this.jwSpine.play({animation:"loose"});
        if(this.jw_mult){
            tl.to(this.jw_mult,{alpha: 0, duration:tl.duration()/4},0);
        }
        return tl;
    }

    public remove(): void {
        this.children.forEach(child => { child.destroy(); });
        this.destroy({ children: true });
    }
}